import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  ENABLE_ACCOMMODATIONS,
  USE_REFACTOR,
  PRIOR_SAILING_HOURS,
  appRoutes
} from '../../configuration/constants'

import DefaultCrossingCard from './DefaultCrossingCard/DefaultCrossingCard'
import ShipNameCrossingCard from './ShipNameCrossingCard/ShipNameCrossingCard'
import {
  selectDepartureRoute,
  selectReturnRoute
} from '../../redux/ferryRouteSelections/selectors'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

const CrossingCardContainer = ({
  crossing,
  selectCrossing,
  isDisabled,
  isCurrentlySelectedRoute,
  activeVehicleResourceCode,
  activeVehicle,
  shouldDisplayNoPassengerMessage,
  cabinResourceCodes
}) => {
  const { pathname } = useLocation()
  const departureRoute = useSelector(selectDepartureRoute)
  const returnRoute = useSelector(selectReturnRoute)
  const isDeparturePage = pathname.includes(appRoutes.departure.pathname)
  const { departureDate } = crossing
  let accommodationsAvailable = false
  let vehiclesAvailable
  let isOverNight
  let isDisabledParam = isDisabled
  let isCutOff = false
  let departureWaitList = false
  let returnWaitList = false
  let waitListAvailable = false

  if (USE_REFACTOR) {
    accommodationsAvailable = crossing.accommodationsAvailable
    vehiclesAvailable = crossing.vehiclesAvailable
    isOverNight = crossing.isOvernight
    isDisabledParam = crossing.isDisabled
  } else {
    const { formattedResources, departureTime } = crossing
    const crossingVehicles = formattedResources?.vehicles || []

    const filteredVehicles = activeVehicleResourceCode
      ? crossingVehicles.filter(
          vehicle => vehicle.resourceCode === activeVehicleResourceCode
        )
      : crossingVehicles

    vehiclesAvailable = filteredVehicles.some(vehicle => {
      return activeVehicle?.vehicleLength
        ? +vehicle.availableCapacity >= activeVehicle?.vehicleLength
        : +vehicle.availableCapacity > 0
    })

    const hasWaitListAvailable = (route, cabins) => {
      if (!route?.waitListLimit?.length) return false

      for (const cabin of cabins) {
        if (!cabinResourceCodes.includes(cabin.resourceCode)) continue

        const waitListed = Number(cabin.waitListed) || 0
        const waitListMax = Number(cabin.maxWaitListable) || 0
        if (waitListed < waitListMax) {
          return true
        }
      }
      return false
    }

    if (ENABLE_ACCOMMODATIONS) {
      const cabins = formattedResources.accommodations || []
      accommodationsAvailable = cabins.some(
        accommodation =>
          cabinResourceCodes.includes(accommodation.resourceCode) &&
          +accommodation.freeCapacity > 0
      )
      departureWaitList = hasWaitListAvailable(departureRoute, cabins)
      returnWaitList = hasWaitListAvailable(returnRoute, cabins)
      if (isDeparturePage) {
        waitListAvailable = departureWaitList
      } else {
        waitListAvailable = returnWaitList
      }
    }

    const departureTimeNumber = +moment(departureTime, 'HH:mm').format('HHmm')
    isOverNight = departureTimeNumber > 0 && departureTimeNumber < 400
    isCutOff =
      typeof crossing.hoursToDeparture === 'undefined' ||
      crossing.hoursToDeparture <= PRIOR_SAILING_HOURS
  }

  if (process.env.REACT_APP_CROSSING_CARD_LAYOUT === 'ship_name') {
    return (
      <ShipNameCrossingCard
        accommodationsAvailable={accommodationsAvailable}
        crossing={crossing}
        departureDate={departureDate}
        isCurrentlySelectedRoute={isCurrentlySelectedRoute}
        isDisabled={isDisabledParam}
        isOverNight={isOverNight}
        selectCrossing={selectCrossing}
        vehiclesAvailable={vehiclesAvailable}
        shouldDisplayNoPassengerMessage={shouldDisplayNoPassengerMessage}
        isCutOff={isCutOff}
        waitListAvailable={waitListAvailable}
      />
    )
  }

  return (
    <DefaultCrossingCard
      accommodationsAvailable={accommodationsAvailable}
      crossing={crossing}
      departureDate={departureDate}
      isCurrentlySelectedRoute={isCurrentlySelectedRoute}
      isDisabled={isDisabledParam}
      isOverNight={isOverNight}
      selectCrossing={selectCrossing}
      vehiclesAvailable={vehiclesAvailable}
      isCutOff={isCutOff}
    />
  )
}

CrossingCardContainer.propTypes = {
  crossing: PropTypes.shape().isRequired,
  selectCrossing: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isCurrentlySelectedRoute: PropTypes.bool,
  activeVehicleResourceCode: PropTypes.string,
  activeVehicle: PropTypes.shape(),
  cabinResourceCodes: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default CrossingCardContainer
